import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import {
  // AnalyticsModule,
  // AnalyticsRouterModule,
  // FormatterModule,
  TranslatePipe,
} from '@dch/ng-common/src/lib/translation';

import {
  ModalModule,
  LoadingSpinnerModule,
  CurrencyAmountModule,
  DecimalPartPipe,
  IntegerPartPipe,
} from '@dch/ng-common-components';

import { AppRoutingModule } from './app-routing.module';
import { MyBillAppComponent } from './my-bill/my-bill-app.component';
import { SafeUrlPipe } from './my-bill/common/pipe/safe-url.pipe';
import { BillingAddressService } from './my-bill/services/billing-address-service';
import { CallDetailsTableComponent } from './my-bill/call-details/components/call-details-table/call-details-table.component';
import { StoreModule } from '@ngrx/store';
import { reducers } from './state/reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './state/effects';
import { SummaryPipe } from './my-bill/call-details/pipes/summary.pipe';
import { SummaryDurationPipe } from './my-bill/call-details/pipes/summary-duration.pipe';
import { SummaryAmountPipe } from './my-bill/call-details/pipes/summary-amount.pipe';
import { BackButtonComponent } from './my-bill/common/back-button/back-button.component';
import { MyBillOverviewContainerComponent } from './my-bill/overview/my-bill-overview-container.component';
import { MyBillTransactionSkeletonCardComponent } from './my-bill/overview/transactions/my-bill-transaction-skeleton-card.component';
import { MyBillBillingAccountContainerComponent } from './my-bill/overview/billing-accounts/my-bill-billing-account-container.component';
import { MyBillBillingAccountCardComponent } from './my-bill/overview/billing-accounts/my-bill-billing-account-card.component';
import { MyBillAccountCardComponent } from './my-bill/overview/redesign/my-bill-account-card.component';
import { MyBillBalanceCardComponent } from './my-bill/overview/redesign/my-bill-balance-card.component';
import { MyBillPayButtonContainerComponent } from './my-bill/overview/redesign/my-bill-pay-button-container.component';
import { MyBillSliceInvoiceItemComponent } from './my-bill/overview/redesign/my-bill-slice-invoice-item.component';
import { MyBillBillingAccountBalanceComponent } from './my-bill/overview/billing-accounts/my-bill-billing-account-balance.component';
import { MyBillOverviewSkeletonComponent } from './my-bill/overview/my-bill-overview-skeleton.component';
import { MyBillOverviewRedesignSkeletonComponent } from './my-bill/overview/my-bill-overview-redesign-skeleton.component';
import { MyBillTransactionCardHeaderComponent } from './my-bill/overview/transactions/my-bill-transaction-card-header.component';
import { MyBillNothingToPayCardComponent } from './my-bill/overview/transactions/my-bill-nothing-to-pay-card.component';
import { MyBillTransactionCardAmountComponent } from './my-bill/overview/transactions/my-bill-transaction-card-amount.component';
import { MyBillPromiseOfPaymentContainerComponent } from './my-bill/overview/promise-of-payment/my-bill-promise-of-payment-container.component';
import { MyBillAccountSkeletonCardComponent } from './my-bill/overview/billing-accounts/my-bill-account-skeleton-card.component';
import { MyBillAccountSelectionComponent } from './my-bill/overview/my-bill-account-selection.component';
import { MyBillPdfDocumentComponent } from './my-bill/one-digital-bill/common/my-bill-pdf-document.component';
import { MyBillDownloadCardComponent } from './my-bill/overview/redesign/my-bill-download-card.component';
import { MyBillCallDetailsComponent } from './my-bill/overview/call-details-modal/my-bill-call-details-modal.component';
import { MyBillPayButtonComponent } from './my-bill/overview/payment/my-bill-pay-button.component';
import { MyBillLoginRequiredComponent } from './my-bill/overview/login-required-modal/my-bill-login-required-modal.component';
import { MyBillModalLoginRequiredComponent } from './my-bill/overview/login-required-modal/my-bill-modal-login-required.component';
import { ExplanationSectionComponent } from './my-bill/common/explanation-section/explanation-section.component';
import { configureEntityManager } from './my-bill/common/initializer';
import { CategoryHeaderComponent } from './my-bill/details/category-header.component';
import { CategorySectionComponent } from './my-bill/details/category-section.component';
import { CategorySectionItemComponent } from './my-bill/details/category-section-item.component';
import { CategoryTotalAmountComponent } from './my-bill/details/category-total-amount.component';
import { ThirdPartyInfoBoxComponent } from './my-bill/details/third-party-info-box.component';
import { BillingAnalyticsService } from './my-bill/services/billing-analytics.service';
import { RemoteLoggerService } from './my-bill/services/remote-logger.service';
import { UtilsService } from './my-bill/services/utils.service';
import { CBUOnlyGuard } from './guards/cbu-only.guard';
import { MyProximusAuthenticationCheckGuard } from './guards/myproximus-authentication-check.guard';
import { BillingCustomerService } from './my-bill/services/billing-customer.service';
import { MyBillTokenExpiredComponent } from './my-bill/overview/token-expired/my-bill-token-expired.component';
import { MyBillAnalyticsNavigationDirective } from './my-bill/directives/my-bill-analytics-navigation.directive';
import { OdbCategoryDetailsPageComponent } from './my-bill/one-digital-bill/odb-category-details-page.component';
import { CoverPageComponent } from './my-bill/one-digital-bill/cover-page.component';
import { CoverNoDetailsPageComponent } from './my-bill/one-digital-bill/cover-no-details-page.component';
import { CoverDetailsComponent } from './my-bill/one-digital-bill/cover-details.component';
import { OdbDivisionIdentifierComponent } from './my-bill/one-digital-bill/odb-division-identifier.component';
import { OdbExplanationSectionComponent } from './my-bill/common/odb-explanation-section/odb-explanation-section.component';
import { OdbTotalComponent } from './my-bill/one-digital-bill/odb-total.component';
import { OdbSubTotalComponent } from './my-bill/one-digital-bill/odb-sub-total.component';
import { ShowMoreButtonComponent } from './my-bill/common/show-more-button/show-more-button.component';
import { CoverDetailsDivisionComponent } from './my-bill/one-digital-bill/cover-details-division.component';
import { OdbBillDocumentInfoComponent } from './my-bill/one-digital-bill/odb-bill-document-info.component';
import { OdbVatProductSplitComponent } from './my-bill/one-digital-bill/category-details/odb-vat-product-split.component';
import { OdbThirdPartyProductSplitComponent } from './my-bill/one-digital-bill/category-details/odb-third-party-product-split.component';
import { OdbSubscriptionProductSplitComponent } from './my-bill/one-digital-bill/category-details/odb-subscription-product-split.component';
import { OdbUsageAndOtcProductSplitComponent } from './my-bill/one-digital-bill/category-details/odb-usage-and-otc-product-split.component';
import { OdbProductSplitIdentifierComponent } from './my-bill/one-digital-bill/category-details/odb-product-split-identifier.component';
import { OdbSectionVariantTwoComponent } from './my-bill/one-digital-bill/category-details/odb-section-variant-two.component';
import { OdbCategorySectionsComponent } from './my-bill/one-digital-bill/category-details/odb-category-sections.component';
import { OdbCategoryDetailsIdentifierComponent } from './my-bill/one-digital-bill/category-details/odb-category-details-identifier.component';
import { OdbDownloadCsvComponent } from './my-bill/one-digital-bill/common/odb-download-csv.component';
import { OdbCoverDetailsDivisionsComponent } from './my-bill/one-digital-bill/odb-cover-details-divisions.component';
import { OdbCategoryDetailsComponent } from './my-bill/one-digital-bill/category-details/odb-category-details.component';
import { OdbCategorySectionOrItemVariantOneComponent } from './my-bill/one-digital-bill/category-details/odb-category-section-or-item-variant-one.component';
import { OdbProductSplitHeaderComponent } from './my-bill/one-digital-bill/category-details/odb-product-split-header.component';
import { OdbSettlementProductSplitComponent } from './my-bill/one-digital-bill/category-details/odb-settlement-product-split.component';
import { OdbThirdPartyLevelThreeComponent } from './my-bill/one-digital-bill/category-details/odb-third-party-level-three.component';
import { OdbThirdPartyLevelThreePageComponent } from './my-bill/one-digital-bill/category-details/odb-third-party-level-three-page.component';
import { OdbThirdPartyLevel4PageComponent } from './my-bill/one-digital-bill/category-details/odb-third-party-level-4-page.component';
import { DeferralLandingPageComponent } from './my-bill/deferral/deferral-landing-page.component';
import { DeferralRulesListComponent } from './my-bill/deferral/deferral-rules-list.component';
import { BillingBackToPreviousScreenService } from './my-bill/services/billing-back-to-previous-screen.service';
import { MyScarletService } from './my-bill/services/my-scarlet.service';
import { OdbUsageLevelThreePageComponent } from './my-bill/one-digital-bill/odb-usage-level-three-page.component';
import { ScrollToTopComponent } from './my-bill/common/scroll-to-top/scroll-to-top.component';
import { OdbPageBaseStructureComponent } from './my-bill/common/design-base-structure/odb-page-base-structure.component';
import { OdbUsageLevelFourPageComponent } from './my-bill/one-digital-bill/odb-usage-level-four-page.component';
import { MyBillDetailsAndOptionsButtonComponent } from './my-bill/overview/details-and-options/my-bill-details-and-options-button.component';
import { MyBillDeferralCardComponent } from './my-bill/deferral/deferral-card/my-bill-deferral-card.component';
import { BillOptionsComponent } from './my-bill/billing-options/bill-options.component';
import { BillOptionsPaymentFacilitiesInfoPageComponent } from './my-bill/billing-options/bill-options-payment-facilities-info-page.component';
import { DeferralAcceptNewDatePageComponent } from './my-bill/deferral/deferral-accept-new-date-page.component';
import { DeferralSelectDatePageComponent } from './my-bill/deferral/deferral-select-date-page.component';
import { DeferralSuccessfulNewDatePageComponent } from './my-bill/deferral/deferral-successful-new-date-page.component';
import { OdbUsageLevelFourTablePaginationComponent } from './my-bill/one-digital-bill/table-pagination/odb-usage-level-four-table-pagination.component';
import { DurationPipe } from './my-bill/one-digital-bill/table/duration.pipe';
import { OdbUsageLevelFourTableHeaderComponent } from './my-bill/one-digital-bill/table-header/odb-usage-level-four-table-header.component';
import { OdbUsageLevelFourTableHeaderReorderColumnsModalComponent } from './my-bill/one-digital-bill/table-header/reorder-columns-modal/odb-usage-level-four-header-reorder-columns-modal.component';
import { PdfErrorOverlayerComponent } from './my-bill/common/pdf-error/pdf-error-overlayer.component';
import { MyBillLandingSkeletonComponent } from './my-bill/overview/my-bill-landing-skeleton.component';
import { MyBillLandingContainerComponent } from './my-bill/overview/my-bill-landing-container.component';
import { MyBillOverviewHeaderComponent } from './my-bill/overview/my-bill-overview-header.component';
import { MyBillFaqSettingsContainerComponent } from './my-bill/overview/faq-settings/my-bill-faq-settings-container.component';
import { MyBillFaqComponent } from './my-bill/overview/faq-settings/my-bill-faq.component';
import { MyBillTransactionCardComponent } from './my-bill/overview/transactions/my-bill-transaction-card.component';
import { MyBillInstalmentPlanCardComponent } from './my-bill/instalment-plan/my-bill-instalment-plan-card.component';
import { MyBillInstalmentPlanDetailsPageComponent } from './my-bill/instalment-plan/my-bill-instalment-plan-details-page.component';
import { MyBillInstalmentPlanProgressBarComponent } from './my-bill/instalment-plan/my-bill-instalment-plan-progress-bar.component';
import { FormatPositiveAmountService } from './my-bill/services/format-positive-amount.service';
import { MyBillEvolutionChartPageComponent } from './my-bill/evolution/my-bill-evolution-chart-page.component';
import { MyBillEvolutionChartSkeletonComponent } from './my-bill/evolution/my-bill-evolution-chart-skeleton.component';
import { MyBillEvolutionTabComponent } from './my-bill/evolution/my-bill-evolution-tab.component';
import { EvolutionChartComponent } from './my-bill/evolution/evolution-chart.component';
import { EvolutionChartLegendComponent } from './my-bill/evolution/evolution-chart-legend.component';
import { EvolutionChartNewCustomerPanelComponent } from './my-bill/evolution/evolution-chart-new-customer-panel.component';
import { OdbBillDocumentExplanationIntroComponent } from './my-bill/one-digital-bill/odb-bill-document-explanation-intro.component';
import { ExplanationComponent } from './my-bill/one-digital-bill/explanations/explanation.component';
import { OdbBillExplanationIntroComponent } from './my-bill/one-digital-bill/odb-bill-explanation-intro.component';
import {
  DSOverlayerMessageComponent,
  DSOverlayerComponent,
  DSMessageBoxComponent,
  DSSpinnerComponent,
  DSProgressBarComponent,
} from '@dch/pxs-angular-design-system';
import { TransactionReferenceService } from './my-bill/services/transaction-reference.service';
import { ExpiredTokenComponent } from './my-bill/common/expired-token/expired-token.component';
import { FileDownloaderService } from './my-bill/services/file-downloader.service';

@NgModule({
  declarations: [
    MyBillAppComponent,
    MyBillOverviewContainerComponent,
    MyBillBillingAccountContainerComponent,
    MyBillOverviewSkeletonComponent,
    MyBillOverviewRedesignSkeletonComponent,
    MyBillTransactionSkeletonCardComponent,
    MyBillAccountSkeletonCardComponent,
    MyBillTransactionCardHeaderComponent,
    MyBillNothingToPayCardComponent,
    MyBillTransactionCardAmountComponent,
    MyBillPromiseOfPaymentContainerComponent,
    MyBillBillingAccountCardComponent,
    MyBillAccountCardComponent,
    MyBillBalanceCardComponent,
    MyBillPayButtonContainerComponent,
    MyBillSliceInvoiceItemComponent,
    MyBillBillingAccountBalanceComponent,
    MyBillAccountSelectionComponent,
    MyBillPdfDocumentComponent,
    MyBillDownloadCardComponent,
    SafeUrlPipe,
    SummaryPipe,
    SummaryDurationPipe,
    SummaryAmountPipe,
    CallDetailsTableComponent,
    BackButtonComponent,
    MyBillCallDetailsComponent,
    MyBillPayButtonComponent,
    MyBillLoginRequiredComponent,
    MyBillModalLoginRequiredComponent,
    ExplanationSectionComponent,
    OdbExplanationSectionComponent,
    OdbCategoryDetailsPageComponent,
    CategoryHeaderComponent,
    CategorySectionComponent,
    CategorySectionItemComponent,
    CategoryTotalAmountComponent,
    ThirdPartyInfoBoxComponent,
    MyBillTokenExpiredComponent,
    MyBillAnalyticsNavigationDirective,
    CoverPageComponent,
    CoverNoDetailsPageComponent,
    CoverDetailsComponent,
    OdbDivisionIdentifierComponent,
    OdbTotalComponent,
    OdbSubTotalComponent,
    ShowMoreButtonComponent,
    CoverDetailsDivisionComponent,
    OdbBillDocumentInfoComponent,
    OdbVatProductSplitComponent,
    OdbSettlementProductSplitComponent,
    OdbThirdPartyProductSplitComponent,
    OdbSubscriptionProductSplitComponent,
    OdbUsageAndOtcProductSplitComponent,
    OdbProductSplitIdentifierComponent,
    OdbSectionVariantTwoComponent,
    OdbCategorySectionsComponent,
    OdbCategorySectionOrItemVariantOneComponent,
    OdbCategoryDetailsIdentifierComponent,
    OdbDownloadCsvComponent,
    OdbCoverDetailsDivisionsComponent,
    OdbCategoryDetailsComponent,
    OdbProductSplitHeaderComponent,
    OdbThirdPartyLevelThreePageComponent,
    OdbThirdPartyLevelThreeComponent,
    OdbThirdPartyLevel4PageComponent,
    OdbUsageLevelThreePageComponent,
    ScrollToTopComponent,
    OdbPageBaseStructureComponent,
    OdbUsageLevelFourPageComponent,
    OdbUsageLevelFourTablePaginationComponent,
    OdbUsageLevelFourTableHeaderComponent,
    OdbUsageLevelFourTableHeaderReorderColumnsModalComponent,
    DeferralLandingPageComponent,
    DeferralRulesListComponent,
    MyBillDetailsAndOptionsButtonComponent,
    BillOptionsComponent,
    BillOptionsPaymentFacilitiesInfoPageComponent,
    MyBillDeferralCardComponent,
    DeferralSelectDatePageComponent,
    DeferralAcceptNewDatePageComponent,
    DeferralSuccessfulNewDatePageComponent,
    DurationPipe,
    PdfErrorOverlayerComponent,
    MyBillLandingSkeletonComponent,
    MyBillLandingContainerComponent,
    MyBillOverviewHeaderComponent,
    MyBillFaqSettingsContainerComponent,
    MyBillFaqComponent,
    MyBillTransactionCardComponent,
    MyBillInstalmentPlanCardComponent,
    MyBillInstalmentPlanProgressBarComponent,
    MyBillInstalmentPlanDetailsPageComponent,
    MyBillEvolutionChartPageComponent,
    MyBillEvolutionChartSkeletonComponent,
    MyBillEvolutionTabComponent,
    EvolutionChartComponent,
    EvolutionChartLegendComponent,
    EvolutionChartNewCustomerPanelComponent,
    OdbBillDocumentExplanationIntroComponent,
    OdbBillExplanationIntroComponent,
    ExplanationComponent,
    ExpiredTokenComponent,
    // DSOverlayerMessageComponent,
    // DSMessageBoxComponent,
    // DSSpinnerComponent
  ],
  bootstrap: [MyBillAppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LoadingSpinnerModule,
    //  AlertModule,
    ModalModule,
    //  TranslationModule,
    //  FormatterModule,
    CurrencyAmountModule,
    //  FormatterModule,
    FormsModule,
    ReactiveFormsModule,
    //  AnalyticsModule,
    //  AnalyticsRouterModule,
    StoreModule.forRoot(reducers),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forRoot(effects),
    TranslatePipe,
    DSSpinnerComponent,
    DSMessageBoxComponent,
    DSOverlayerMessageComponent,
    DSProgressBarComponent,
    DSOverlayerComponent,
  ],
  providers: [
    BillingAddressService,
    BillingAnalyticsService,
    MyScarletService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureEntityManager,
      multi: true,
    },
    RemoteLoggerService,
    UtilsService,
    CBUOnlyGuard,
    MyProximusAuthenticationCheckGuard,
    BillingCustomerService,
    BillingBackToPreviousScreenService,
    FormatPositiveAmountService,
    IntegerPartPipe,
    DecimalPartPipe,
    provideHttpClient(withInterceptorsFromDi()),
    TransactionReferenceService,
    FileDownloaderService,
  ],
})
export class AppModule {}
